export function getTimeZoneAbbreviation(cityName) {
  const options = {
    timeZone: `America/${cityName.replace(/\s+/g, '_')}`,
    timeZoneName: 'short'
  };

  const formatter = new Intl.DateTimeFormat('en-CA', options);
  const timeZoneAbbreviation = formatter.formatToParts(new Date())
    .find(part => part.type === 'timeZoneName').value;

  return timeZoneAbbreviation;
}